import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
import { Flame, Zap, Activity, Scale, AlertCircle, BoxIcon } from 'lucide-react';
const symptoms = [{
  icon: Flame,
  title: 'Burning Sensation',
  description: 'A feeling like your feet or hands are on fire, especially noticeable at night.'
}, {
  icon: Zap,
  title: 'Tingling & Numbness',
  description: "A 'pins and needles' feeling or complete loss of sensation in your extremities."
}, {
  icon: Activity,
  title: 'Sharp, Stabbing Pain',
  description: 'Sudden, intense pain that feels like electric shocks or stabbing.'
}, {
  icon: Scale,
  title: 'Balance Problems',
  description: 'Feeling unsteady on your feet, leading to a fear of falling.'
}, {
  icon: AlertCircle,
  title: 'Extreme Sensitivity',
  description: "Pain from things that shouldn't hurt, like the weight of a blanket."
}, {
  icon: BoxIcon,
  title: 'Muscle Weakness',
  description: 'Difficulty gripping objects or feeling like your legs might give out.'
}];
export function Symptoms() {
  return <section id="neuropathy" className="py-20 bg-background" data-id="element-199">
      <div className="container mx-auto px-4" data-id="element-200">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-201">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4 text-foreground" data-id="element-202">
            Are You Experiencing These Symptoms?
          </h2>
          <p className="text-lg text-muted-foreground" data-id="element-203">
            Peripheral neuropathy is a progressive condition. If left untreated,
            these symptoms often worsen over time, leading to permanent nerve
            damage.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-204">
          {symptoms.map((symptom, index) => {
          const Icon = symptom.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-205">
                <Card className="h-full border-muted/50 hover:border-primary/50 transition-colors" data-id="element-206">
                  <CardContent className="p-6 flex flex-col items-start gap-4" data-id="element-207">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center" data-id="element-208">
                      <Icon className="w-6 h-6 text-primary" data-id="element-209" />
                    </div>
                    <div data-id="element-210">
                      <h3 className="font-bold text-xl mb-2" data-id="element-211">
                        {symptom.title}
                      </h3>
                      <p className="text-muted-foreground" data-id="element-212">
                        {symptom.description}
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}